import { render } from "./CardItem.vue?vue&type=template&id=15f421f0&scoped=true&ts=true"
import script from "./CardItem.vue?vue&type=script&lang=ts"
export * from "./CardItem.vue?vue&type=script&lang=ts"

import "./CardItem.vue?vue&type=style&index=0&id=15f421f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f421f0"]])

export default __exports__